import React, { Component } from 'react';

import classNames from 'classnames';
import { Loader } from 'components/loader';
import { I18n } from 'components/translate';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { generateId } from 'modules/content/helper';
import PropTypes from 'prop-types';

import RadiolistItem from './RadiolistItem';

import './Radiolist.scss';

@observer
class Radiolist extends Component {
  static propTypes = {
    allowUncheck: PropTypes.bool,
    className: PropTypes.string,
    onChange: PropTypes.func,
    items: MobxPropTypes.arrayOrObservableArray,
    loading: PropTypes.bool,
    name: PropTypes.string,
    selectedOption: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      radiolistId: generateId(),
      selectedOption: props.selectedOption
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.selectedOption !== prevProps.selectedOption &&
      this.props.selectedOption !== this.state.selectedOption
    ) {
      this.setState({ selectedOption: this.props.selectedOption });
    }
  }

  onChange = (event) => {
    const { onChange } = this.props;
    const { name, value, type } = event.target;

    this.setState({ selectedOption: value });

    onChange && onChange({ target: { name, value, type } });
  };

  onClick = (event) => {
    if (this.props.allowUncheck) {
      this.onChange(event);
    }
  };

  isOptionSelected(value) {
    return value && value === this.state.selectedOption;
  }

  render() {
    const {
      name,
      items = [],
      className,
      loading,
      allowUncheck,
      ...props
    } = this.props;

    const classComponent = classNames('radiolist', className);

    return (
      <ul className={classComponent}>
        {items.length > 0 &&
          items.map((item, index) => {
            const key = `radiolist__${this.state.radiolistId}__item__${index}`;

            return (
              <RadiolistItem
                {...props}
                id={key}
                key={key}
                name={name}
                item={item}
                checked={this.isOptionSelected(item.value)}
                onClick={allowUncheck ? this.onClick.bind(this) : () => ({})}
                onChange={!allowUncheck ? this.onChange.bind(this) : () => ({})}
              />
            );
          })}

        {!items.length && (
          <li className="radiolist__item radiolist__item--no-result-found">
            <I18n label="general.no_result_found" />
          </li>
        )}

        {loading && <Loader key="loader" mask />}
      </ul>
    );
  }
}

export default Radiolist;
